<template>
  <span class="employee-calendar-daynumber">{{ day.getDate() }}</span>
    <span v-if="absence" v-tooltip :title="absence.name.join(' / ') + (absence.half_holiday ? ' (1/2 Feiertag)' : '')" class="employee-calendar-day-icons">
    <span v-if="absence.vacation && !absence.from_flextime && !absence.unpaid && hours > 0" class="material-symbols-outlined">beach_access</span>
    <span v-if="absence.vacation && absence.from_flextime && hours > 0" class="material-symbols-outlined">schedule</span>
    <span v-if="absence.unpaid && hours > 0" class="material-symbols-outlined">money_off</span>
    <span v-if="absence.vacation && !absence.granted && hours > 0" class="material-symbols-outlined">hourglass</span>
    <a v-if="user.id == employee.user_id && absence.vacation && !absence.granted && hours > 0" @click.stop="deleteVacationRequest(k)" href="#">
      <span class="material-symbols-outlined">delete</span>
    </a>
    <button :disabled="absence.has_open_revoke_request" class="transparent text-primary" v-if="user.id == employee.user_id && absence.vacation && absence.granted && absence.start_at > to_luxon_ISOdate_fromJSDate(new Date())" @click.stop="sendRevokeRequest(k)" href="#">
      <span class="material-symbols-outlined">delete</span>
    </button>
    <span v-if="absence.has_open_revoke_request" class="material-symbols-outlined text-success" style="font-size:15px;" v-tooltip
        :title="$trans.get('__JSON__.There is already a revoke request open')">
        info
    </span>
    <span v-if="absence.holiday" class="material-symbols-outlined">event</span>
    <span v-if="absence.half_holiday" class="material-symbols-outlined">½</span>
    <span v-if="absence.sick" class="material-symbols-outlined">sick</span>
    <span v-if="absence.sick_without" class="material-symbols-outlined">coronavirus</span>
    <span v-if="absence.vacation && absence.special_leave" class="material-symbols-outlined">star_rate</span>
    <span v-if="absence.half_day && hours > 0" class="material-symbols-outlined">&frac12;</span>

    <span v-if="absence.next_absence && absence.next_absence.vacation && !absence.next_absence.from_flextime && !absence.next_absence.unpaid && hours > 0" class="material-symbols-outlined">beach_access</span>
    <span v-if="absence.next_absence && absence.next_absence.vacation && absence.next_absence.from_flextime && hours > 0" class="material-symbols-outlined">schedule</span>
    <span v-if="absence.next_absence && absence.next_absence.unpaid && hours > 0" class="material-symbols-outlined">money_off</span>
    <span v-if="absence.next_absence && absence.next_absence.vacation && !absence.next_absence.granted && hours > 0" class="material-symbols-outlined">hourglass</span>
    <span v-if="absence.next_absence && absence.next_absence.half_day" class="material-symbols-outlined">½</span>
    <span v-if="!absence.vacation && !absence.weekend && !absence.holiday && !absence.sick && !absence.sick_without" class="material-symbols-outlined">autopause</span>
  </span>
  <a v-if="links && day.getDay() == 0" :href="journalLink">
    <span class="material-symbols-outlined text-white">visibility</span>
  </a>

  <span v-if="worked" class="material-symbols-outlined text-success float-end">check</span>
  <span v-if="hasTeamEvents" class="material-symbols-outlined text-info float-end" data-bs-html="true" v-tooltip :title="teamEventsNames">event_note</span>
</template>

<script>
import { DateTime } from "luxon";
export default {

  name: "EmployeeCalendarDay",

  props: {
    day: Object,
    absence: Object,
    journalLink: String,
    worked: Boolean,
    links: Boolean,
    hours: Number,
    team_id: Number,
    teameventnames: Object,
    hasTeamEvents: Boolean,
    teamEventsNames: String,
    user: null,
    employee: null
  },
  methods:{
    deleteVacationRequest(index) {
            if (confirm("Are you sure you want to delete the vacation request?")) {
                axios
                    .delete("/api/vacations/" + this.absence.id)
                    .then((resp) => {
                        self.errors = [];
                        location.reload();
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors;
                    });
            }
        },
        sendRevokeRequest() {
          if (confirm("Are you sure you want to cancel the vacation?")) {
            axios
                .post("/api/employees/" + this.absence.employee_id + "/revokerequest", {
                    absenceid: this.absence.id,
                })
                .then((resp) => {
                    self.errors = [];
                    location.reload();
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                });
              }
        },
        to_luxon_ISOdate_fromJSDate(date) {
            var formattedDate = DateTime.fromJSDate(date).toISODate();
            return formattedDate;
        },
  }

  
}
</script>
